import axios from 'axios';

export const homepageConfigService = {
  async getAll() {
    const res = await axios.get('/web/homepage-sections');
    return res.data.data || [];
  },
};
